import script from "./HealthDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthDashboard.vue?vue&type=script&setup=true&lang=js"

import "./HealthDashboard.vue?vue&type=style&index=0&id=de4c13fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de4c13fc"]])

export default __exports__